// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopicProgress_wrapper__2GbfR","progress":"TopicProgress_progress__27uWD","text":"TopicProgress_text__3yk4T"};